export default [
  {
    original: require("../images/slides/slide0.jpg"),
    thumbnail: require("../images/slides/slide0.jpg")
  },
  {
    original: require("../images/slides/slide1.jpg"),
    thumbnail: require("../images/slides/slide1.jpg")
  },
  {
    original: require("../images/slides/slide2.jpg"),
    thumbnail: require("../images/slides/slide2.jpg")
  }
];



// WEBPACK FOOTER //
// ./src/components/gallerylists/imagesmain.js